<h1 class="matp-page-title">システムエラー</h1>

<mat-card class="matp-card">
  <p>
    予期せぬアプリケーションエラーが発生しました。<br />
    しばらく待ってから再度操作を行ってください。<br />
    状況が改善しない場合は管理者にご連絡ください。
  </p>

  <div>
    <a routerLink="/">ホーム画面へ戻る</a>
  </div>
</mat-card>
